// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import NoDataCell from '../NoDataCell';
import { formatMessage } from '@/utils/i18n/i18n';
import { ESGColourDefinition, CarbonIntensityLimit } from '@/enums/Esg';
import ComparisonItem from '@/types/comparison-item';
import DisclaimerInfos from '@/types/disclaimer-infos';
import Locale from '@/types/locale';

type Props = {
  value?: number;
  className?: string;
  item?: ComparisonItem;
  disclaimer?: string;
  onClick?: () => void;
  id?: string;
  valueDisclaimer?: DisclaimerInfos;
  hasDisclaimer?: boolean;
  locale?: Locale;
};

const CarbonIntensityCell: React.FunctionComponent<Props> = ({
  value,
  className,
  disclaimer,
  valueDisclaimer,
  item,
  onClick,
  id,
  hasDisclaimer,
  locale,
}: Props) => {
  if (value == null) {
    return <NoDataCell disclaimerKey={disclaimer} item={item} onClick={onClick} id={id} locale={locale} />;
  }

  const fixedValue = +value.toFixed(1);

  let carbonIntensityColor;
  let carbonIntensityLabel;
  const units = formatMessage('ESGComparisonTool.Carbon.IntensityUnit');

  switch (true) {
    case fixedValue < CarbonIntensityLimit.VERY_LOW:
      carbonIntensityColor = ESGColourDefinition.TEXT_ALIGNED;
      carbonIntensityLabel = formatMessage('ESGComparisonTool.Carbon.Intensity.VERY_LOW');
      break;
    case fixedValue < CarbonIntensityLimit.LOW:
      carbonIntensityColor = ESGColourDefinition.TEXT_ALIGNED;
      carbonIntensityLabel = formatMessage('ESGComparisonTool.Carbon.Intensity.LOW');
      break;
    case fixedValue < CarbonIntensityLimit.MODERATE:
      carbonIntensityColor = ESGColourDefinition.TEXT_MODERATE;
      carbonIntensityLabel = formatMessage('ESGComparisonTool.Carbon.Intensity.MODERATE');
      break;
    case fixedValue < CarbonIntensityLimit.HIGH:
      carbonIntensityColor = ESGColourDefinition.TEXT_STRONGLY_MISALIGNED;
      carbonIntensityLabel = formatMessage('ESGComparisonTool.Carbon.Intensity.HIGH');
      break;
    default:
      carbonIntensityColor = ESGColourDefinition.TEXT_STRONGLY_MISALIGNED;
      carbonIntensityLabel = formatMessage('ESGComparisonTool.Carbon.Intensity.VERY_HIGH');
      break;
  }

  return (
    <div className={classNames(className, 'cell esg-rating-cell')} id={id ? `cell-${id}` : undefined} style={{ color: carbonIntensityColor }} onClick={onClick}>
      <span className="markup-container">
        {fixedValue} {units} ({carbonIntensityLabel})
      </span>
    </div>
  );
};

export default CarbonIntensityCell;
